import { Fragment, useState } from "react"
import ReactPaginate from "react-paginate"
import DataTable from "react-data-table-component"
import { ChevronDown, MoreVertical, Edit3, PlusCircle, XCircle } from "react-feather"

// ** Reactstrap Imports
import { Card, Input, Button, UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle, Modal } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { customStyles, isCurrentDayInRange, isCurrentTimeInRange } from "../../utils"
import { useEffect } from "react"
// import { data } from "../../../../utility/genericServicesData"
// import { genericServicesColumnList } from "../genericServicesOptions"
// import { getGenericServiceAll } from "../../../../utility/myGenericServiceApiCenter"
import { stockColumnList } from "../tableColumn"
import { getAllStr, postForceStopbyStrId, postRestartSocketbyStrId } from "../../myApiCenter"
import MainNav from "../MainNav/MainNav"
import StockTradeModal from "./StockTradeModal"
import toast from "react-hot-toast"
import ErrorUserModal from "./ErrorUserModal"
import CallPutData from "./CallPutData"
import RefreshToast from "../Componant/refreshToast"

const StrList = () => {
   const navigate = useNavigate()

   const [currentPage, setCurrentPage] = useState(0)
   const [rowsPerPage, setRowsPerPage] = useState(10)
   const [data, setdata] = useState([])
   const [isErrorUserModal, setisErrorUserModal] = useState(false)
   const [isTradeModal, setisTradeModal] = useState(false)
   const [stockDetail, setstockDetail] = useState(null)
   const getData = async () => {
      try {
         const j = await getAllStr()
         // console.log(j)
         setdata(j?.data?.str)
         console.log(j?.data?.str[0])
      } catch (error) {
         console.log(error)
      }
   }
console.log(data)
   const columns = [
      ...stockColumnList,
      {
         name: "Action",
         allowoverflow: true,
         cell: (row) => {
            if (!row.isSocketConnected && isCurrentTimeInRange()) {
               toast.dismiss()
               toast.custom(<RefreshToast title={row.name} onClick={() => toast.dismiss()} />, {
                  duration: 8000,
                  style: {
                     borderTopLeftRadius: "250px"
                  }
               })
            }

            return (
               <div className="d-flex">
                  <UncontrolledDropdown>
                     <DropdownToggle style={{ cursor: "pointer" }} className="pe-1" tag="span">
                        <MoreVertical size={15} />
                     </DropdownToggle>
                     <DropdownMenu end>
                        <DropdownItem
                           tag="div"
                           className="w-100"
                           onClick={() => {
                              navigate(`/str/edit/${row._id}`)
                           }}
                        >
                           <Edit3 size={24} />
                           <span className="align-middle ms-50">Edit Info</span>
                        </DropdownItem>
                        <DropdownItem
                           tag="div"
                           className="w-100"
                           onClick={() => {
                              // console.log(row)
                              postRestartSocketbyStrId(row?._id)
                           }}
                        >
                           <Edit3 size={24} />
                           <span className="align-middle ms-50">Restart Server</span>
                        </DropdownItem>
                        <DropdownItem
                           tag="div"
                           className="w-100"
                           onClick={() => {
                              // console.log(row)
                              postForceStopbyStrId(row?._id)
                           }}
                        >
                           <Edit3 size={24} />
                           <span className="align-middle ms-50">Force Stop For Today</span>
                        </DropdownItem>
                     </DropdownMenu>
                  </UncontrolledDropdown>
               </div>
            )
         }
      }
   ]

   // ** Function to handle Pagination
   const handlePagination = (page) => {
      setCurrentPage(page.selected)
   }
   const handlePerPage = (e) => {
      setCurrentPage(0)
      setRowsPerPage(parseInt(e.target.value))
   }
   useEffect(() => {
      // Store interval ID so we can clear it later
      const intervalId = setInterval(() => {
         console.log('called every time')
         if (isCurrentDayInRange()) {
            getData()
         }
         
      }, 2000)
      getData()
      // Clear interval on component unmount
      return () => {
         console.log('called clea')
         clearInterval(intervalId)
      }
   }, [])
   // console.log(data)
   // ** Custom Pagination
   const ExpandableTable = ({ data }) => {
      return (
         <div className="expandable-content p-2">
            <CallPutData data={data} />
         </div>
      )
   }
   const CustomPagination = (props) => {
      return (
         <div className="d-flex mt-3 justify-content-between">
            <div>
               {currentPage * rowsPerPage + 1} TO {(currentPage + 1) * rowsPerPage < data.length ? (currentPage + 1) * rowsPerPage : data.length} of{" "}
               {data.length} items
            </div>
            <div className="d-flex gap-3">
               <ReactPaginate
                  previousLabel=""
                  nextLabel=""
                  forcePage={data.length > rowsPerPage ? currentPage : 0}
                  onPageChange={(page) => handlePagination(page)}
                  pageCount={Math.ceil(data.length / rowsPerPage) || 1}
                  breakLabel="..."
                  pageRangeDisplayed={2}
                  marginPagesDisplayed={2}
                  activeClassName="active"
                  pageClassName="page-item"
                  breakClassName="page-item"
                  nextLinkClassName="page-link"
                  pageLinkClassName="page-link"
                  breakLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextClassName="page-item next-item"
                  previousClassName="page-item prev-item"
                  containerClassName="pagination react-paginate separated-pagination pagination-sm justify-content-end pe-1 mt-1"
               />

               <div>
                  <Input
                     type="select"
                     id="rows-per-page"
                     value={rowsPerPage}
                     onChange={(e) => {
                        props.onChangeRowsPerPage(e.target.value)
                        handlePerPage(e)
                     }}
                     className="page-selector"
                  >
                     <option value="5">5</option>
                     <option value="7">7</option>
                     <option value="10">10</option>
                     <option value="15">15</option>
                     <option value="25">25</option>
                     <option value="50">50</option>
                  </Input>
               </div>
            </div>
         </div>
      )
   }

   // console.log(data)

   return (
      <Fragment>
         <MainNav />
         <Modal isOpen={isTradeModal} toggle={() => setisTradeModal(!isTradeModal)} className="modal-dialog-centered modal-lg">
            <div className="d-flex justify-content-between w-100 p-2">
               <h4> {stockDetail?.path === "place-order-for-all" ? "Place Order For All" : "Square Off Trade"} </h4>
               <XCircle
                  style={{ cursor: "pointer" }}
                  className="cursor-pointer"
                  onClick={() => {
                     setisTradeModal(false)
                     setstockDetail(null)
                     toast.dismiss()
                  }}
               />
            </div>

            <StockTradeModal setisModelOpen={setisTradeModal} stockDetail={stockDetail} />
         </Modal>
         <Modal isOpen={isErrorUserModal} toggle={() => setisErrorUserModal(!isErrorUserModal)} className="modal-dialog-centered modal-lg">
            <div className="d-flex justify-content-between w-100 p-2">
               <h4> Error User List </h4>
               <XCircle
                  style={{ cursor: "pointer" }}
                  className="cursor-pointer"
                  onClick={() => {
                     setisErrorUserModal(false)
                     setstockDetail(null)
                     toast.dismiss()
                  }}
               />
            </div>
            <ErrorUserModal setisModelOpen={setisErrorUserModal} stockDetail={stockDetail} />
         </Modal>
         <Card className="m-5 p-3 main-table">
            <div className="react-dataTable react-dataTable-selectable-rows">
               <DataTable
                  customStyles={customStyles}
                  pagination
                  columns={columns}
                  paginationPerPage={rowsPerPage}
                  className="react-dataTable"
                  sortIcon={<ChevronDown size={10} />}
                  paginationComponent={CustomPagination}
                  paginationDefaultPage={currentPage + 1}
                  data={data}
                  expandableRows
                  expandOnRowClicked
                  expandableRowsComponent={ExpandableTable}
                  subHeader={true}
                  subHeaderComponent={
                     <div className="d-flex p-1 w-100 justify-content-between align-items-center">
                        <h1 className="datatable-title-head">STRETAGIES</h1>
                        <div className="d-flex gap-1 align-items-center">
                           <Button className="my-btn" onClick={() => navigate("/str/add")}>
                              <PlusCircle />
                              &nbsp; Add New Stretagy
                           </Button>
                        </div>
                     </div>
                  }
               />
            </div>
         </Card>
      </Fragment>
   )
}
export default StrList
